import { CapitalStatus } from '@/types';

export const getIsStatusFundedOrEval = (status: CapitalStatus) => {
  return ![CapitalStatus.NOT_ELIGIBLE, CapitalStatus.UNKNOWN].includes(status);
};

export const getIsStatusFunded = (status: CapitalStatus) => {
  return [
    CapitalStatus.PRE_FUNDED,
    CapitalStatus.FUNDED,
    CapitalStatus.FUNDED_BLOCKED,
    CapitalStatus.FUNDED_FAILED_MAX_DAILY_LOSS,
    CapitalStatus.FUNDED_FAILED_MAX_DRAWDOWN,
  ].includes(status);
};

export const getIsStatusEval = (status: CapitalStatus) => {
  return getIsStatusFundedOrEval(status) && !getIsStatusFunded(status);
};

export const getIsStatusEvalEnd = (status: CapitalStatus) => {
  return [
    CapitalStatus.GOAL_PASSED,
    CapitalStatus.GOAL_FAILED_MAX_DRAWDOWN,
    CapitalStatus.GOAL_FAILED_MAX_DAILY_LOSS,
  ].includes(status);
};

export const getIsStatusFundedEnd = (status: CapitalStatus) => {
  return [
    CapitalStatus.FUNDED_FAILED_MAX_DAILY_LOSS,
    CapitalStatus.FUNDED_FAILED_MAX_DRAWDOWN,
  ].includes(status);
};

export const getIsStatusBlocked = (status: CapitalStatus) => {
  return [CapitalStatus.BLOCKED, CapitalStatus.FUNDED_BLOCKED].includes(status);
};

export const getIsStatusEnd = (status: CapitalStatus) => {
  return getIsStatusEvalEnd(status) || getIsStatusFundedEnd(status);
};

export const getIsStatusPreEval = (status: CapitalStatus) => {
  return [
    CapitalStatus.UNKNOWN,
    CapitalStatus.PAID,
    CapitalStatus.PRE_EVAL,
    CapitalStatus.NOT_ELIGIBLE,
  ].includes(status);
};

export const getIsStatusEvalOrFundedActive = (status: CapitalStatus) => {
  return [CapitalStatus.ACTIVE, CapitalStatus.FUNDED].includes(status);
};
